import React from 'react';
import { Card } from 'react-bootstrap';
import PageHeader from 'components/common/PageHeader';
import {Link} from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Scheda02 = () => {
  const handleDownload = () => {

    const link = document.createElement('a');
    link.href = '/app/assets/pdf/SCHEDA-2_Tabelle.pdf'; 
    link.download = 'SCHEDA-2_Tabelle.pdf';
    link.click();
  };

  return (<>
    <PageHeader
    title="Scheda 02"
    description="CRITERI PROPOSTA BASE AMBITI DI IMPATTO (Allegato 2/1) E FINANZIARI (Allegato 2/2)"
    className="mb-3"
    >
    </PageHeader>
    
    <Card style={{marginTop:"2%", marginBottom:"2%"}}>
        <Card.Body>
          <Card.Text>
            <p>Per definire la <strong>proposta base CSVC</strong> è stato individuato il minimo comun denominatore derivante dall’abbinamento seguente tra le <strong>opportunità sociali delle catena del valore CSV</strong> ed i temi delle norme <strong>CSRD</strong>, le categorie degli <strong>ESG</strong>, gli standard <strong>GRI</strong> per la prospettiva inside-out della <strong>materialità d’impatto</strong> e tra <strong>le dimensioni del contesto competitivo CSV</strong> e gli indicatori core <strong>PAI</strong> per la prospettiva outside-in della <strong>materialità finanziaria</strong>, in modo da  soddisfare entrambe queste due prospettive ed allo stesso tempo minimizzare il numero degli ambiti da cui le aziende possono selezionare quelli principali a loro congegnali (v. tabelle allegate).</p>
            <p>In particolare per la materialità d’impatto sono stati aggiunte le opportunità di nuovi prodotti e mercati considerati solo da <strong>CSV</strong> ed in coerenza con gli <strong>ambiti CSRD</strong> non sono state considerate le compliance ambientali e sociali e la valutazione del rispetto dei diritti umani degli standard <strong>GRI</strong> in quanto generiche e già comprese in altri ambiti più specifici ma sono state considerati anche diversi sottotemi/sotto-sottotemi <strong>CSRD</strong> in conseguenza del recepimento del maggiore numero di Standard <strong>GRI</strong>. Per la <strong>materialità finanziaria</strong> sono stati aggiunti gli ambiti necessari per coprire tutte le corrispondenze con gli ambiti della <strong>materialità d’impatto</strong></p>
            <br />    
            <button onClick={handleDownload}>Apri tabelle allegate</button>
          </Card.Text>
          <Card.Footer>
              <Link to="/app/metodologia/fase-a">
                <FontAwesomeIcon icon="chevron-left" className="ms-1 fs-11" />&nbsp;&nbsp;&nbsp;
                Torna all'elenco delle schede della fase A EFRAG 
              </Link>
           </Card.Footer>
        </Card.Body>
      </Card>

    </>)
};

export default Scheda02;
